import { render } from "./DataCollection.vue?vue&type=template&id=6d4da9d6"
import script from "./DataCollection.vue?vue&type=script&lang=js"
export * from "./DataCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__